module.exports = __webpack_public_path__ + "static/media/fa-solid-900.ef3df984.eot";